import Form from "../components/Form";
import LatestTransactions from "../components/Tansactions/LatestTransactions";
import Balance from "../components/Balance";

const Home = () => {
	return (
		<>
			<Balance />
			<Form />
			<LatestTransactions />
		</>
	);
};

export default Home;
